import { Box, Flex } from 'components/layout';
import * as Icons from 'components/icons';
import { Text } from 'components/typography';

type ProjectCardProps = {
  projectName: string;
  signedBy: string;
  date: string;
};

export const ProjectCard = ({
  projectName,
  signedBy,
  date,
}: ProjectCardProps) => {
  return (
    <Box
      sx={{
        border: '1px solid',
        borderColor: '#e9eaeb',
        borderRadius: '16px',
        p: 4,
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        backgroundColor: 'white',
        boxShadow: 'sm',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        '&:hover': {
          boxShadow: 'md',
          borderColor: 'primary.300',
        },
      }}
    >
      <Flex
        sx={{
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          mb: 3,
        }}
      >
        <Box
          sx={{
            p: 2,
            backgroundColor: '#e3effd',
            borderRadius: 8,
          }}
        >
          <Icons.FolderOn
            width={24} color="#2d5cf3"
            strokeWidth={4}
          />
        </Box>
        <Box
          sx={{
            px: 2,
            py: 1,
            backgroundColor: '#e5e7eb',
            borderRadius: 4,
            fontSize: 'xs',
            fontWeight: 600,
            color: '#6c7180',
          }}
        >
          Project
        </Box>
      </Flex>
      <Text
        sx={{
          fontWeight: 600,
          fontSize: 'lg',
          color: '#111827',
          mb: 2,
        }}
      >
        {projectName}
      </Text>
      <Flex sx={{ flexDirection: 'column', gap: 1 }}>
        <Flex sx={{ alignItems: 'center', gap: 2 }}>
          <Icons.Profile width={14} color="#6b7280" />
          <Text sx={{ fontSize: 'sm', color: '#6b7280' }}>
            Signed by:{' '}
            <span style={{ color: '#384051', fontWeight: 500 }}>
              {signedBy}
            </span>
          </Text>
        </Flex>
        <Flex sx={{ alignItems: 'center', gap: 2 }}>
          <Box sx={{ color: '#6b7280' }}>
            <Icons.CalendarToday width={14} />
          </Box>
          <Text sx={{ fontSize: 'sm', color: '#6b7280' }}>{date}</Text>
        </Flex>
      </Flex>
      <Box
        sx={{
          borderTop: '1px solid',
          borderColor: '#e5e7eb',
          mt: 8,
          pt: 3,
        }}
      >
        <Flex sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
          <Text sx={{ fontSize: 'sm', color: '#6b7280' }}>View details</Text>
          <Icons.ChevronRight width={5} color="#6b7280" />
        </Flex>
      </Box>
    </Box>
  );
};
